<template>
  <div class="ht300-chart">
    <v-chart class="chart" :options="chartValOp" :autoresize="true" />
  </div>
</template>

<script>
export default {
  props: {
    chartValOp: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped lang="scss">
.ht300-chart {
  width: 100%;
  overflow-x: hidden;

  box-sizing: border-box;
  --chart-h: 200px;
  @media screen and (max-width: 1200px) {
    --chart-h: 140px;
  }

  .chart {
    width: 100% !important;
    height: var(--chart-h) !important;
  }
}
</style>
